export const emit_dropsonde_data = function(id_prefix, sub_type) {
    return (options) => {
        const get_skew_options = (options) => {
            const { data_time, geometry, data_path } = options.feature
            const [ lat, lon, ] = geometry.coordinates
            return  {
                title: data_time,
                latlng: [ lat, lon, ],
                url: data_path,
            }
        }

        this.skew_options = get_skew_options(options)
        this.is_show_chart_dialog = true
        this.chart_type = 'dropsonde'
    }
}